module.exports = __webpack_public_path__ + "img/orbit-simplicity-long-cropped.be25af1f.jpg";